// --------------------------------------------------------
// CARELINE OCCUPHEALTH DETAIL - CareLineOccupHealthDetail
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../..";
import CardPeriodicAtendimentoArea from "../../../../components/cardPeriodic/CardPeriodicAtendimentoArea";
import CardPeriodicExamArea from "../../../../components/cardPeriodic/CardPeriodicExamArea";
import GenericModal from "../../../../components/genericModal/GenericModal";
import ContainerWithSidebar from "../../../../components/UI/containerWithSidebar/ContainerWithSidebar";
import Styled from "./CareLineOccupHealthDetail.styled";
import {
  GeneralContainer,
  H1,
  TextLink,
} from "../../../../components/UI/generalLayout/Layout.styled";
import Colors from "../../../../constants/Colors";
import useResponsiveInfo from "../../../../hooks/useResponsiveInfo";
import { CancelButton } from "./AttachCareLine";
import RequestAppointmentModal from "./RequestAppointmentModal";
import * as careLineActions from "../../../../store/actions/careLine";
import { Paths } from "../../../../enums/Paths";
import { GenericSolidButton } from "../../../../components/UI/buttons/Button.styled";
import { AppointmentService } from "../../../../core/http/service/AppointmentService";
import { useSelector } from "react-redux";
// --------------------------------------------------------
// CARELINE OCCUPHEALTH DETAIL INTERFACE
// --------------------------------------------------------

/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function CareLineOccupHealthDetail(): JSX.Element {
  // --------------------------------------------------------
  // CARELINE OCCUPHEALTH DETAIL PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();
  const { state } = useLocation();
  const { careLine, isCareLine, pessoa }: any = state;
  const { currentProfile }: any = useSelector((state: any) => state.login);
  const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [showDetachCareLineModal, setShowDetachCareLineModal] =
    useState<boolean>(false);
  const [showRequestAppointmentModal, setShowRequestAppointmentModal] =
    useState<boolean>(false);

  const detachCareLine = useCallback(async () => {
    await dispatch(
      careLineActions.detachCareLineFromPerson(careLine.id, pessoa.idPessoa)
    );
  }, [careLine, pessoa]);

  const onDetachClick = () => {
    detachCareLine();
    onNavigateToProntuario();
  };

  const onNavigateToProntuario = () => {
    navigate(Paths.Prontuario, { state: { pessoa: pessoa } });
  };

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <TextLink color={Colors.SPM600} onClick={onNavigateToProntuario}>
          {"< Voltar para o prontuário"}
        </TextLink>
        <div
          style={{
            flexDirection: isMobile ? "column" : "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <H1>{careLine.nome}</H1>
          
          {
            !acessoProntuario ? 
              isCareLine && (
                <CancelButton
                  style={{ width: 250, height: 50 }}
                  onClick={() => {
                    setShowDetachCareLineModal(true);
                  }}
                >
                  Desvincular linha de cuidado
                </CancelButton>
              )
            :
              ''
          }
        </div>
        <div
          style={{
            flexDirection: isMobile ? "column" : "row",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 40,
            marginBottom: 15,
          }}
        >
          <H1>Atendimento</H1>
          {
            !acessoProntuario ? 
              isCareLine && (
                <GenericSolidButton
                  style={{ width: 250, height: 50 }}
                  onClick={() => {
                    setShowRequestAppointmentModal(true);
                  }}
                  color={Colors.SPM600}
                >
                  Solicitar próxima consulta
                </GenericSolidButton>
              )
            :
              ''
          }
        </div>

        {careLine.categorias.map((c: any) => {
          return (
            <CardPeriodicAtendimentoArea
              data={c}
              onClickInnerSetAppointment={() => {}}
              isCareLine={true}
            />
          );
        })}
        <div style={{ marginTop: 40, marginBottom: 15 }}>
          <H1>Exames</H1>
          {careLine.exames.map((ex: any) => {
            return <CardPeriodicExamArea exame={ex} />;
          })}
        </div>
      </GeneralContainer>

      <RequestAppointmentModal
        idPaciente={pessoa.idPessoa}
        visible={showRequestAppointmentModal}
        categorias={careLine.categorias}
        refreshCategoria={onNavigateToProntuario}
        onCancelar={() => {
          setShowRequestAppointmentModal(false);
        }}
      />

      <GenericModal
        visible={showDetachCareLineModal}
        onConfirm={() => {
          setShowDetachCareLineModal(false);
        }}
        onCancel={onDetachClick}
        modalTitle={
          "Tem certeza que deseja desvincular o paciente dessa linha de cuidado?"
        }
        modalSubtitle={
          "A linha de cuidado não fará mais parte do perfil do paciente caso desvinculado."
        }
        cancelButtonMsg={"Voltar"}
        confirmButtonMsg={"Desvincular"}
      />
    </ContainerWithSidebar>
  );
}

export default CareLineOccupHealthDetail;
